import { Injectable, inject } from '@angular/core';
import {
  BaseResultApiModel,
  ExtraDataApiModel,
  HotelRoomApiModel,
  RoomsService,
  StateService,
} from '@rocksoft/inroom-sdk';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoomsApi {
  private readonly roomService = inject(RoomsService);
  private readonly stateService = inject(StateService);

  public getRooms(hotelCode: string): Observable<HotelRoomApiModel[]> {
    return this.roomService.getRooms({ hotelCode });
  }

  public getRoom(hotelCode: string, unitCode: string): Observable<HotelRoomApiModel> {
    return this.roomService.getRoom({ hotelCode, unitCode });
  }

  public addRoom(hotelCode: string, unitCode: string): Observable<HotelRoomApiModel> {
    return this.roomService.addRoom({ hotelCode, unitCode });
  }

  public deleteRoom(hotelCode: string, unitCode: string): Observable<BaseResultApiModel> {
    return this.roomService.deleteRoom({ hotelCode, unitCode });
  }

  public checkoutRoom(hotelCode: string, unitCode: string): Observable<BaseResultApiModel> {
    return this.stateService.checkout({ hotelCode, room: unitCode });
  }

  public updateExtraData(hotelCode: string, unitCode: string, data: ExtraDataApiModel) {
    return this.stateService.airplayCredentials({ hotelCode, room: unitCode, extraDataApiModel: data });
  }
}
